module.exports = __webpack_public_path__ + "img/接收分享.90fea64d.svg";